<button 
  mat-raised-button 
  [color]="color"
  class="add-new-button" 
  (click)="onClick()"
  [disabled]="disabled"
  [matTooltip]="tooltip"
  [matTooltipPosition]="tooltipPosition">
  <mat-icon>{{ icon }}</mat-icon>
  {{ text }}
</button>